// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__FhYlE","spin":"Loader_spin__KDwTG","sm":"Loader_sm__0YRtE","md":"Loader_md__DF-tS","lg":"Loader_lg__QJHc6"};